import React from 'react';
import styled from 'styled-components';
import { FlexColumn, Flex } from '@ubeya/shared-web/components';
import { responsiveRow } from '@ubeya/shared-web/style';

const Wrapper = styled(Flex)`
  flex: 1;
  overflow: hidden;
  opacity: ${({ submitting }) => (submitting ? 0.3 : 1)};
  pointer-events: ${({ submitting }) => (submitting ? 'none' : 'all')};
`;

const Page = styled(FlexColumn)`
  ${responsiveRow.tablet}
  overflow: auto;
  flex: 1;
  display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
`;

const TabContent = ({ activeTab, submitting, children }) => (
  <Wrapper submitting={submitting}>
    {React.Children.map(
      children,
      (child) => !!child && <Page isVisible={activeTab === child.props.activeTab}>{child}</Page>
    )}
  </Wrapper>
);

export default TabContent;
